$(function() {
    $('[data-bs-toggle="tooltip"]').tooltip();
});
